export let Status = [
  {
    key: 1,
    name: "ATIVO",
  },
  {
    key: 0,
    name: "INATIVO",
  },
];

export function convertCondition(condition) {
  if (condition) {
    return { value: "BOM", color: "success" };
  } else {
    return { value: "RUIM", color: "danger" };
  }
}
